import { Directive, ViewContainerRef, OnChanges, SimpleChanges, Input } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { EventService } from '../services/event.service';
/* 通过指令获取http实例的请求状态 */
@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[http-host]',
})
export class HttpDirective implements OnChanges {
  constructor(public http: _HttpClient, private event: EventService) {}
  @Input() loading: boolean;

  _HTTP_LOADING_EVENT_NAME = 'http-loading-change';

  ngOnChanges(): void {
    this.event.change(this._HTTP_LOADING_EVENT_NAME, this.loading);
  }
}
